import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function postGCalsToSync(
  calendars: CalendarEntryToSync[],
) {
  const res = await fetchOrchidAPI(
    "/api/scheduler_calendar_integrations/sync_google_calendars",
    {
      method: "POST",
      body: JSON.stringify({
        calendars,
      }),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
